<div class="graph-container">
  <div class="graph-header">
    <a [routerLink]="['/details', data.therapeuticArea.id]">{{
      data.therapeuticArea.name | titlecase
    }}</a>
    <button class="secondary" *ngIf="false">
      <mat-icon>file_download</mat-icon>
      Download
    </button>
  </div>

  <div class="chart-section">
    <app-compliance-wheel
      [data]="data"
      [indexChanged]="indexChangedSubject.asObservable()"
      (onIndexChange)="selectIndexFromChild($event)"
    ></app-compliance-wheel>
  </div>
  <a
    class="compliance-item {{ item.colorName }}"
    *ngFor="let item of data.elements; let i = index"
    routerLink="/details/{{ data.therapeuticArea.id }}/{{ item.link }}"
    [class.selected]="selectedIndex === i"
  >
    <span class="item-pill item-score {{ item.colorName }}">
      <mat-icon>{{ item.icon }}</mat-icon>
    </span>
    <span class="item-name">{{ item.elementName }}</span>
    <span class="item-pill {{ item.colorName }} item-percent">{{
      calculatePercent(item.value)
    }}</span>
  </a>
</div>
